<template>
  <v-dialog
    :value="isEnabled"
    @click:outside="handleCancel"
    width="600px"
  >
    <v-card>
      <v-form ref="form-editfield">
        <v-card-title class="headline">{{ title }}</v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-text-field
                v-model="field.name"
                :rules="rules.name"
                :label="$t('commons.field_name')"
                counter="1000"
                maxlength="1000"
                outlined
              >
              </v-text-field>
            </v-row>
            <v-row>
              <v-select
                v-model="field.type"
                :items="items"
                :rules="rules.type"
                :label="$t('commons.fieldtype')"
                item-text="name"
                items-value="id"
                outlined
                return-object
              >
              </v-select>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="handleSave"
            >{{ $t("commons.save") }}</v-btn
          >
          <v-btn
            color="error"
            @click="handleCancel"
            >{{ $t("commons.cancel") }}</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { FieldTypeService } from "@/services/documents"
// import { required, slug, max64 } from "@/utils/validator"
import { required } from "@/utils/validator"

export default {
  name: "EditFieldDialog",
  props: {
    isEnabled: { type: Boolean, required: true },
    companyId: { type: Number, required: true },
    rulesUpdate: { type: Object, default: () => ({}) },
    title: { type: String, default: "Edit field" },
    value: { type: Object, required: true }
  },
  created() {
    this.fetchFieldTypes()
  },
  data() {
    return {
      items: [],
      field: Object.assign({}, this.value)
    }
  },
  computed: {
    rules() {
      return {
        //name: [required, slug, max64],
        name: [required],
        type: [required],
        ...this.rulesUpdate
      }
    }
  },
  methods: {
    async fetchFieldTypes() {
      this.items = await FieldTypeService.getAll(this.companyId, { company: this.companyId })
    },
    handleCancel() {
      this.$emit("cancel")
    },
    handleSave() {
      if (this.validate()) {
        this.$emit("save", this.field)
      }
    },
    validate() {
      return this.$refs["form-editfield"].validate()
    }
  }
}
</script>
